export const adminSidebarData = [
  {
    name: "Administrador",
    iconClass: "fas fa-user-shield",
    child: [
      {
        routepath: "/admin/project/create",
        listname: "Editar Projetos",
        iconClass: "fas fa-pencil-alt"
      },
      {
        routepath: "/admin/notifications",
        listname: "Enviar notificação",
        iconClass: "fas fa-bell"
      },
      {
        routepath: "/admin/painel-controle",
        listname: "Painel de Controle",
        iconClass: "fas fa-database"
      },
      {
        routepath: "/admin/dashboards",
        listname: "Dashboards",
        iconClass: "fas fa-chart-pie"
      },
      {
        routepath: "/admin/stripe/dashboard",
        listname: "Dashboard Stripe",
        iconClass: "fas fa-credit-card"
      }
    ]
  }
];
